import { requireRoute } from "@/auth/guard";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/risks")({
  beforeLoad: ({ context }) => requireRoute(context, "/risks"),
});
